import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  ip: string = 'https://a5l1762w9b.execute-api.us-east-1.amazonaws.com/dev';
  
  // Define API
  apiURL =  this.ip + '/go504/api/votaciones/dev/v1';
  imgURL = 'https://l9exw0r619.execute-api.us-east-1.amazonaws.com/dev/go504/api/utils/dev/v1/repo/go504hnrepo';

  constructor(private http: HttpClient, private toastr: ToastrService, private router: Router) { }


  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  // HttpClient API get() method => Fetch Person list
  getPerson(id: String, pageSize: number, condicion: number, pagenum: number): Observable<any> {
    return this.http.get<any>(this.apiURL + '/person/' + id + '?pagesize=' + pageSize + '&condicion=' + condicion + '&pagenum=' + pagenum)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }
  // HttpClient API get() method => update person 
  putPerson(params: any): Observable<any> {
    return this.http.put<any>(this.apiURL + '/person/', params)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }
  setEnablePerson(params: any): Observable<any> {
    return this.http.put<any>(this.apiURL + '/person/habilitar/', params)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }
  GetAllTickets(id: string): Observable<any> {
    return this.http.get<any>(this.apiURL + '/ticket/all/' + id)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  // Para la página pública de validación: sin handleError para no mostrar alertas ni cerrar sesión
  validarTicket(id: String): Observable<any> {
    return this.http.get<any>(this.apiURL + '/ticket/validar/' + id)
      .pipe(
        retry(1)
      )
  }

  GetTicket(id: String): Observable<any> {
    return this.http.get<any>(this.apiURL + '/ticket/' + id)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  // Sin retry ni handleError: si la API responde con error (ej. 401 por credenciales) se devuelve su cuerpo
  // ({ hasError, errors }) para que el login muestre el mensaje
  login(params: any): Observable<any> {
    return this.http.post<any>(this.apiURL + '/login/', params)
      .pipe(
        catchError(error => {
          if (error.error && error.error['hasError']) {
            return of(error.error);
          }
          return throwError(error);
        })
      )
  }
  // Devuelve la URL firmada de S3 de la imagen. Sin handleError: si falla solo se muestra el icono por defecto
  getImagen(keyImg: string, size: number = 600): Observable<string> {
    return this.http.get<any>(this.imgURL + '/' + encodeURIComponent(keyImg) + '/' + size);
      // .pipe(
      //   map(result => {
      //     console.log('[img] respuesta del API', result);
      //     let data = Array.isArray(result) ? result[0] : (result && result['data']) || result;
      //     return data && data['table0'] && data['table0'][0] ? data['table0'][0]['url'] : null;
      //   })
      // );
  }
  getReport(): Observable<any> {
    return this.http.get<any>(this.apiURL + '/report/')
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }


  // Error handling 
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;

    } else {
      // Get server-side error

      if (error.status === 401) {


        localStorage.clear();
        this.router.navigate(['/login']);
      }
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}
